// extracted by mini-css-extract-plugin
module.exports = {"chartWrapper":"SimpleBarChartWrapper_chartWrapper__oykLf"};